import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-66174a43")

_pushScopeId("data-v-66174a43")
const _hoisted_1 = { class: "card mb-5 mb-xl-10 seq-card" }
const _hoisted_2 = { class: "card-body pt-6 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-stack account-details-stats" }
const _hoisted_4 = { class: "d-flex flex-column flex-grow-1 pe-8 account-details-stats-wrapper" }
const _hoisted_5 = { class: "d-flex flex-wrap account-details-stats-row" }
const _hoisted_6 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 account-details-stat" }
const _hoisted_7 = { class: "d-flex align-items-center account-details-stat-value" }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-success me-2" }, null, -1)
const _hoisted_9 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400 account-details-stat-label" }, "Consolidated Balance", -1)
const _hoisted_11 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 account-details-stat" }
const _hoisted_12 = { class: "d-flex align-items-center account-details-stat-value" }
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-success me-2" }, null, -1)
const _hoisted_14 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_15 = { class: "fw-bold fs-6 text-gray-400 account-details-stat-label" }
const _hoisted_16 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 account-details-stat" }
const _hoisted_17 = { class: "d-flex align-items-center account-details-stat-value" }
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-success me-2" }, null, -1)
const _hoisted_19 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400 account-details-stat-label" }, "EC Wallet", -1)
const _hoisted_21 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 account-details-stat" }
const _hoisted_22 = { class: "d-flex align-items-center account-details-stat-value" }
const _hoisted_23 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-success me-2" }, null, -1)
const _hoisted_24 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400 account-details-stat-label" }, "MG Pay", -1)
const _hoisted_26 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 account-details-stat" }
const _hoisted_27 = { class: "d-flex align-items-center account-details-stat-value" }
const _hoisted_28 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3 svg-icon-danger me-2" }, null, -1)
const _hoisted_29 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "75"
}
const _hoisted_30 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400 account-details-stat-label" }, "PGI", -1)
const _hoisted_31 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 account-details-stat" }
const _hoisted_32 = { class: "d-flex align-items-center account-details-stat-value" }
const _hoisted_33 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3 svg-icon-success me-2" }, null, -1)
const _hoisted_34 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "60",
  "data-kt-countup-prefix": "%"
}
const _hoisted_35 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400 account-details-stat-label" }, "Product GC", -1)
const _hoisted_36 = {
  key: 0,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 account-details-stat"
}
const _hoisted_37 = { class: "d-flex align-items-center account-details-stat-value" }
const _hoisted_38 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3 svg-icon-success me-2" }, null, -1)
const _hoisted_39 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "60",
  "data-kt-countup-prefix": "%"
}
const _hoisted_40 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400 account-details-stat-label" }, "Sponsor ID", -1)
const _hoisted_41 = {
  key: 1,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 account-details-stat"
}
const _hoisted_42 = { class: "d-flex align-items-center account-details-stat-value" }
const _hoisted_43 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3 svg-icon-success me-2" }, null, -1)
const _hoisted_44 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "60",
  "data-kt-countup-prefix": "%"
}
const _hoisted_45 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400 account-details-stat-label" }, "Upline ID", -1)
const _hoisted_46 = {
  key: 2,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 account-details-stat"
}
const _hoisted_47 = { class: "d-flex align-items-center account-details-stat-value" }
const _hoisted_48 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3 svg-icon-success me-2" }, null, -1)
const _hoisted_49 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "60",
  "data-kt-countup-prefix": "%"
}
const _hoisted_50 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400 account-details-stat-label" }, "Position", -1)
const _hoisted_51 = {
  key: 3,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 account-details-stat"
}
const _hoisted_52 = { class: "d-flex align-items-center account-details-stat-value" }
const _hoisted_53 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3 svg-icon-success me-2" }, null, -1)
const _hoisted_54 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "60",
  "data-kt-countup-prefix": "%"
}
const _hoisted_55 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400 account-details-stat-label" }, "Date Of Registration", -1)
const _hoisted_56 = {
  key: 4,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 account-details-stat"
}
const _hoisted_57 = { class: "d-flex align-items-center account-details-stat-value" }
const _hoisted_58 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-success me-2" }, null, -1)
const _hoisted_59 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_60 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400 account-details-stat-label" }, " * PCP Enrollment", -1)
const _hoisted_61 = {
  key: 5,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 account-details-stat"
}
const _hoisted_62 = { class: "d-flex align-items-center account-details-stat-value" }
const _hoisted_63 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-success me-2" }, null, -1)
const _hoisted_64 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_65 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400 account-details-stat-label" }, "Total Purchased PCP Product", -1)
const _hoisted_66 = {
  key: 6,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 account-details-stat"
}
const _hoisted_67 = { class: "d-flex align-items-center account-details-stat-value" }
const _hoisted_68 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-success me-2" }, null, -1)
const _hoisted_69 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_70 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400 account-details-stat-label" }, "Target Milestone", -1)
const _hoisted_71 = {
  key: 0,
  class: "account-details-footnote"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_skeleton = _resolveComponent("el-skeleton")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _withDirectives(_createVNode("div", null, [
            _createVNode(_component_el_skeleton, {
              rows: 2,
              animated: ""
            })
          ], 512), [
            [_vShow, _ctx.loadingBalance]
          ]),
          _withDirectives(_createVNode("div", _hoisted_5, [
            _withDirectives(_createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _hoisted_8,
                _createVNode("div", _hoisted_9, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.accountdetailsdata.overAllAvailableBalance).toFixed(2))) + " " + _toDisplayString(_ctx.accountdetailsdata.currency), 1)
              ]),
              _hoisted_10
            ], 512), [
              [_vShow, !_ctx.loadingBalance && _ctx.pt != 'bibo' && _ctx.pt != 'ecc' && _ctx.pt != 'pcp']
            ]),
            _withDirectives(_createVNode("div", _hoisted_11, [
              _createVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode("div", _hoisted_14, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.accountdetailsdata.balance).toFixed(2))) + " " + _toDisplayString(_ctx.accountdetailsdata.currency), 1)
              ]),
              _createVNode("div", _hoisted_15, _toDisplayString(_ctx.user.usid) + " Balance", 1)
            ], 512), [
              [_vShow, !_ctx.loadingBalance && _ctx.pt != 'pcp']
            ]),
            _withDirectives(_createVNode("div", _hoisted_16, [
              _createVNode("div", _hoisted_17, [
                _hoisted_18,
                _createVNode("div", _hoisted_19, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.accountdetailsdata.ewalletbalance).toFixed(2))) + " " + _toDisplayString(_ctx.accountdetailsdata.currency), 1)
              ]),
              _hoisted_20
            ], 512), [
              [_vShow, !_ctx.loadingBalance  && _ctx.pt != 'bibo' && _ctx.pt != 'ecc' && _ctx.pt != 'pcp']
            ]),
            _withDirectives(_createVNode("div", _hoisted_21, [
              _createVNode("div", _hoisted_22, [
                _hoisted_23,
                _createVNode("div", _hoisted_24, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.accountdetailsdata.matchinpaybalance).toFixed(2))) + " " + _toDisplayString(_ctx.accountdetailsdata.currency), 1)
              ]),
              _hoisted_25
            ], 512), [
              [_vShow, !_ctx.loadingBalance  && _ctx.pt != 'bibo' && _ctx.pt != 'ecc' && _ctx.pt != 'pcp' && _ctx.ccode === 0]
            ]),
            _withDirectives(_createVNode("div", _hoisted_26, [
              _createVNode("div", _hoisted_27, [
                _hoisted_28,
                _createVNode("div", _hoisted_29, _toDisplayString(_ctx.accountdetailsdata.travelgc), 1)
              ]),
              _hoisted_30
            ], 512), [
              [_vShow, !_ctx.loadingBalance && _ctx.pt != 'bibo' && _ctx.pt != 'ecc' && _ctx.pt != 'pcp']
            ]),
            _withDirectives(_createVNode("div", _hoisted_31, [
              _createVNode("div", _hoisted_32, [
                _hoisted_33,
                _createVNode("div", _hoisted_34, _toDisplayString(_ctx.accountdetailsdata.productgc), 1)
              ]),
              _hoisted_35
            ], 512), [
              [_vShow, !_ctx.loadingBalance && _ctx.pt != 'bibo' && _ctx.pt != 'ecc' && _ctx.pt != 'pcp']
            ]),
            (!_ctx.loadingBalance && _ctx.pt == 'pcp' && _ctx.packageType == 'PCP')
              ? (_openBlock(), _createBlock("div", _hoisted_36, [
                  _createVNode("div", _hoisted_37, [
                    _hoisted_38,
                    _createVNode("div", _hoisted_39, _toDisplayString(_ctx.pcpdetails.spid), 1)
                  ]),
                  _hoisted_40
                ]))
              : _createCommentVNode("", true),
            false
              ? (_openBlock(), _createBlock("div", _hoisted_41, [
                  _createVNode("div", _hoisted_42, [
                    _hoisted_43,
                    _createVNode("div", _hoisted_44, _toDisplayString(_ctx.pcpdetails.upid), 1)
                  ]),
                  _hoisted_45
                ]))
              : _createCommentVNode("", true),
            false
              ? (_openBlock(), _createBlock("div", _hoisted_46, [
                  _createVNode("div", _hoisted_47, [
                    _hoisted_48,
                    _createVNode("div", _hoisted_49, _toDisplayString(_ctx.pcpdetails.upref == 'L' ? 'Left' : (_ctx.pcpdetails.upref == 'R' ? 'Right' : '')), 1)
                  ]),
                  _hoisted_50
                ]))
              : _createCommentVNode("", true),
            (!_ctx.loadingBalance && _ctx.pt == 'pcp' && _ctx.packageType == 'PCP')
              ? (_openBlock(), _createBlock("div", _hoisted_51, [
                  _createVNode("div", _hoisted_52, [
                    _hoisted_53,
                    _createVNode("div", _hoisted_54, _toDisplayString(_ctx.formatDateMonthDayYear(_ctx.pcpdetails.regDate)), 1)
                  ]),
                  _hoisted_55
                ]))
              : _createCommentVNode("", true),
            (!_ctx.loadingBalance && _ctx.pt == 'pcp' && _ctx.packageType == 'PCP')
              ? (_openBlock(), _createBlock("div", _hoisted_56, [
                  _createVNode("div", _hoisted_57, [
                    _hoisted_58,
                    _createVNode("div", _hoisted_59, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.pcpdetails.pcpEnrollmentFee).toFixed(2))) + " " + _toDisplayString(_ctx.accountdetailsdata.currency), 1)
                  ]),
                  _hoisted_60
                ]))
              : _createCommentVNode("", true),
            (!_ctx.loadingBalance && _ctx.pt == 'pcp' && _ctx.packageType == 'PCP')
              ? (_openBlock(), _createBlock("div", _hoisted_61, [
                  _createVNode("div", _hoisted_62, [
                    _hoisted_63,
                    _createVNode("div", _hoisted_64, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.pcpdetails.pcp_product_total).toFixed(2))) + " " + _toDisplayString(_ctx.accountdetailsdata.currency), 1)
                  ]),
                  _hoisted_65
                ]))
              : _createCommentVNode("", true),
            (!_ctx.loadingBalance && _ctx.pt == 'pcp' && _ctx.packageType == 'PCP')
              ? (_openBlock(), _createBlock("div", _hoisted_66, [
                  _createVNode("div", _hoisted_67, [
                    _hoisted_68,
                    _createVNode("div", _hoisted_69, _toDisplayString(_ctx.numberWithCommas(Number(_ctx.pcpdetails.nextMilestone).toFixed(2))) + " " + _toDisplayString(_ctx.accountdetailsdata.currency), 1)
                  ]),
                  _hoisted_70
                ]))
              : _createCommentVNode("", true)
          ], 512), [
            [_vShow, !_ctx.loadingBalance]
          ]),
          (!_ctx.loadingBalance && _ctx.pt == 'pcp' && _ctx.packageType == 'PCP')
            ? (_openBlock(), _createBlock("p", _hoisted_71, "* PCP Enrollment includes " + _toDisplayString(_ctx.pcpdetails.pcpEnrollmentInclusions), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
})